/**
 * Motivational quote of the day — bundled locally so it NEVER goes down, costs nothing,
 * works offline (member data is precious), and stays on-brand. Rotates deterministically by
 * day of year, so everyone sees the same quote today and a new one tomorrow.
 *
 * (If we ever want fresh quotes, a backend job could refresh this list weekly from a free
 * API like ZenQuotes — but the bundled list guarantees it always works.)
 */
export interface Quote {
  text: string;
  author: string;
}

const QUOTES: Quote[] = [
  { text: 'The body achieves what the mind believes.', author: 'Napoleon Hill' },
  { text: "It never gets easier, you just get stronger.", author: 'Unknown' },
  { text: 'Take care of your body. It’s the only place you have to live.', author: 'Jim Rohn' },
  { text: 'The only bad workout is the one that didn’t happen.', author: 'Unknown' },
  { text: 'Success is the sum of small efforts repeated day in and day out.', author: 'Robert Collier' },
  { text: 'Strength does not come from the body. It comes from the will.', author: 'Unknown' },
  { text: 'Don’t wish for it, work for it.', author: 'Unknown' },
  { text: 'A one-hour workout is 4% of your day. No excuses.', author: 'Unknown' },
  { text: 'Discipline is choosing between what you want now and what you want most.', author: 'Abraham Lincoln' },
  { text: 'You don’t have to be extreme, just consistent.', author: 'Unknown' },
  { text: 'The pain you feel today will be the strength you feel tomorrow.', author: 'Unknown' },
  { text: 'Push yourself, because no one else is going to do it for you.', author: 'Unknown' },
  { text: 'Little by little, a little becomes a lot.', author: 'Tanzanian proverb' },
  { text: 'Your only limit is you.', author: 'Unknown' },
  { text: 'Fall in love with taking care of yourself.', author: 'Unknown' },
  { text: 'Sweat is just fat crying.', author: 'Unknown' },
  { text: 'Motivation gets you started; habit keeps you going.', author: 'Jim Ryun' },
  { text: 'Wake up with determination, go to bed with satisfaction.', author: 'Unknown' },
  { text: 'Train insane or remain the same.', author: 'Unknown' },
  { text: 'Slow progress is still progress.', author: 'Unknown' },
  { text: 'Don’t count the days, make the days count.', author: 'Muhammad Ali' },
  { text: 'The hardest lift of all is lifting your butt off the couch.', author: 'Unknown' },
  { text: 'Be stronger than your excuses.', author: 'Unknown' },
  { text: 'You are one workout away from a good mood.', author: 'Unknown' },
  { text: 'Energy and persistence conquer all things.', author: 'Benjamin Franklin' },
  { text: 'Do something today that your future self will thank you for.', author: 'Unknown' },
  { text: 'It’s going to be a journey. It’s not a sprint to get in shape.', author: 'Kerri Walsh' },
  { text: 'Nothing will work unless you do.', author: 'Maya Angelou' },
  { text: 'A river cuts through rock not because of its power, but its persistence.', author: 'Jim Watkins' },
  { text: 'Rome wasn’t built in a day, but they worked on it every single day.', author: 'Unknown' },
  { text: 'Show up. Especially when you don’t feel like it.', author: 'Unknown' },
  { text: 'Every champion was once a contender who refused to give up.', author: 'Rocky Balboa' },
  { text: 'The difference between try and triumph is a little “umph”.', author: 'Unknown' },
  { text: 'You did not come this far to only come this far.', author: 'Unknown' },
  { text: 'Earn your body.', author: 'Unknown' },
  { text: 'Believe you can and you’re halfway there.', author: 'Theodore Roosevelt' },
];

/** Today's quote — same for everyone today, changes daily. */
export function quoteOfDay(): Quote {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const day = Math.floor((now.getTime() - start.getTime()) / 86_400_000);
  return QUOTES[((day % QUOTES.length) + QUOTES.length) % QUOTES.length];
}
